import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import itemTypes, {ITEM_TYPE} from './constants/itemParameterType.values'
import TextInput from 'components/TextInput';
import Tr from 'translations/Translations';
import Select from 'components/Select';
import PartsTable from 'components/PartsTable';
import validationSheme from './constants/validation.form'
import InputLimits from 'constants/InputLimits';

const limits = InputLimits.procedure.itemParameters;

const style = theme => ({
	root: {

	},
	uploadFile: {
		marginBottom: theme.spacing(2)
	}
})

function AddItemParameterForm({
	classes,
	onSubmit = () => { },
	id,
	initValues,
	partId,
	elementList,
	showParts = true,
}) {

	const getInitialValues = () => {
		if (initValues !== undefined) {
			return {
				...initValues,
				parts: {
					[partId]: true,
				}
			};
		}
		return {
			uiType: ITEM_TYPE.TEXT,
			description: '',
			name: '',
			parts: {
				[partId]: true,
			},
			attachments: null
		}
	}

	const getNames = () => {
		let elementId = elementList.findIndex((x) => x.identity === partId)
		let selected = elementList[elementId].stages[0].itemParameters.map(x => {
			return x.name;
		})
		if (initValues !== undefined) {
			let initValuesName = initValues.name;
			var index = selected.indexOf(initValuesName);
			if (index > -1) {
				selected.splice(index, 1);
			}
		}
		return selected;
	}

	return (
		<Form
			id={id}
			onSubmit={onSubmit}
			initialValues={{
				...getInitialValues(),
				_editable: showParts,
			}}
			validationSchema={validationSheme(getNames())}
		>
			{(formikProps) => (
				<>
					<TextInput
						id='name'
						formikProps={formikProps}
						label={Tr('item_parameter_name')}
						required
						limit={limits.NAME}
					/>
					<Select
						id={'uiType'}
						formikProps={formikProps}
						items={itemTypes}
						label={Tr('item_parameter_type')}
					/>
					<TextInput
						id='description'
						formikProps={formikProps}
						label={Tr('description')}
						multiline
					/>
					{/*<Box component="div" className={classes.uploadFile}>
						<UploadFile
							id="attachments"
							formikProps={formikProps}
							label={Tr("attachment")}
						/>
					</Box>*/}
					{elementList.length > 1 &&
						<PartsTable
							id={'parts'}
							formikProps={formikProps}
							elementList={elementList}
						/>
					}
				</>
			)}
		</Form>
	)
}

AddItemParameterForm.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(AddItemParameterForm);